import React from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { routes } from 'core/routes';
import DrawerLayout from 'layouts/DrawerLayout';

const LayoutSelector: React.FunctionComponent = () => {
    const { pathname } = useLocation();
    const route = matchRoutes(routes, pathname);

    if (!route) {
        return <DrawerLayout />;
    }

    return route[0].route.layout;
};

export default LayoutSelector;
